module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [(!_vm.isShawalla) ? _c('div', [_vm._v(_vm._s(_vm.communityMember.nickname))]) : _vm._e(), _vm._v(" "), (_vm.isShawalla) ? _c('b-popover', {
    attrs: {
      "content": "<i class=\"fa fa-wheelchair fa-2x text-center\" aria-hidden=\"true\"></i>",
      "triggers": ['hover']
    }
  }, [_vm._v(_vm._s(_vm.communityMember.nickname))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCommunityLeader)
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group",
      "aria-label": "Community member actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.communityMember.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n      ")]), _vm._v(" "), (_vm.canEditCommunityMembers) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-ban",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('community.member.confirm.remove'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.removeCommunityMember
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n        ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07e95a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMembersRow.vue
// module id = 469
// module chunks = 0